module.exports = __webpack_public_path__ + "img/duplicate.cb39c885.svg";